import styled from "styled-components/native";

export const SuccessContainer = styled.View`
  text-align: center;
`;
